import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import "../styles/superadmin-layout.css";

const SuperAdminLayout = ({ children, userName, onLogout }) => {

  return (
    <div className="superadmin-layout">

      <div className="superadmin-sidebar">
        <Sidebar onLogout={onLogout} />
      </div>

      <div className="superadmin-main">

        <div className="superadmin-topbar">
          <TopBar userName={userName} onLogout={onLogout} />
        </div>

        <div className="superadmin-content">
          {children}
        </div>

      </div>

    </div>
  );
};

export default SuperAdminLayout;